import React from 'react';

import cn from 'classnames';

import { useCreateAdminConversationCategoryQuery } from '@features/AdminConversationCreateCategory/api/hooks/useCreateAdminConversationCategoryQuery';
import { useAdminConversationCreateCategory } from '@features/AdminConversationCreateCategory/lib/hooks/useAdminConversationCreateCategory';
import { Icon, UiButton } from '@shared/ui';

import cls from './AdminConversationCreateCategory.module.css';

interface AdminConversationCreateCategoryProps {
    classes?: string;
}

export const AdminConversationCreateCategory = ({
    classes,
}: AdminConversationCreateCategoryProps) => {
    const { t } = useAdminConversationCreateCategory();
    const { mutateAsync } = useCreateAdminConversationCategoryQuery();

    const createCategory = async () => {
        await mutateAsync();
    };

    return (
        <div className={cn(cls.AdminConversationCreateCategory, [classes])}>
            <UiButton
                onClick={createCategory}
                startIcon={<Icon iconName="plus" />}
                btnText={t('AdminConversationCreateCategory.return.UiButton.btnText')}
            />
        </div>
    );
};
